import styled, { css } from 'styled-components';
import Button from '../../../_shared/components/Button';
import isOmpPlatform from '../../../_shared/utils/isOmpPlatform';

const isOmp = isOmpPlatform();

export const ModalContent = styled.div`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  margin: 0px auto;
  width: 500px;
  padding: 30px 30px;
  font-size: ${({ theme }) => theme.FONT_SIZES.XXLARGE};
  line-height: 53px;
  position: relative;
`;

export const ModalCloseButton = styled.button`
  padding: 6px 24px;
  border: 2px solid
    ${({ theme }) => theme.COLORS.BASE_INVERTED};
  background-color: ${({ theme }) => theme.COLORS.BASE};
  margin: 20px;
  margin-left: auto;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  display: inline-block;
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  border-radius: 4px;
  height: 36px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  }
`;

export const ModalSaveButton = styled(Button)`
  padding: 6px 24px;
  border: 2px solid ${({ theme }) => theme.COLORS.TERTIARY};
  background-color: ${({ theme }) => theme.COLORS.TERTIARY};
  margin: 20px;
  margin-right: 0px;
  margin-left: 0px;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  display: inline-block;
  color: ${({ theme }) => theme.COLORS.BASE};
  border-radius: 4px;
  height: 36px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const ModalButtonContainer = styled.div`
  text-align: right;
  float: right;
  ${isOmp &&
    css`
      width: 440px;
    `}
`;
